import { render, staticRenderFns } from "./IconMinusOutline.vue?vue&type=template&id=475a5920"
import script from "./IconMinusOutline.vue?vue&type=script&lang=js"
export * from "./IconMinusOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports